import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_EAU_APPLICATIONS = gql`
  query getSalaryTypes($companyId: String!, $queryOptions: QueryOptionsInput) {
    getEauApplications(companyId: $companyId, queryOptions: $queryOptions) {
      collection {
        _id
        type
        status
        employeeId
        employee {
          employeePersonalInfo {
            employeeNumber
          }
          profile {
            displayName
          }
        }
        firstDay
        lastDay
        healthInsurance {
          _id
          name
        }
        companyId
        createdAt
        createdBy
      }
      totalCount
    }
  }
`;

export const useGetEauApplications = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'createdAt', sortBy: 1 },
  ]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_EAU_APPLICATIONS, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  const eauApplications = data?.getEauApplications || {};

  return {
    collection: eauApplications?.collection || [],
    loading,
    paginationConfig: {
      total: eauApplications?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'createdAt', sortBy }]);
      }
    },
  };
};
